import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=a81e1c62&scoped=true"
var script = {}
import style0 from "./AuthLayout.vue?vue&type=style&index=0&id=a81e1c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81e1c62",
  null
  
)

export default component.exports